module.exports = __webpack_public_path__ + "img/reorder.204e1d66.png";